import {getUserManagementUser} from "@project/sdk/user-management";
import {GetUserManagementUserResponse} from "@project/sdk/user-management/zod";
import {queryOptions} from "@tanstack/react-query";

import {queryPolicyDefaults} from "../../../../../shared/query/query-policies";
import {userManagementUserKeys} from "../../../userManagementUser-keys";

export function getUserManagementUserQueryOptions(userId: string) {
  return queryOptions({
    ...queryPolicyDefaults.warm,
    queryKey: userManagementUserKeys.detail(userId),
    queryFn: async ({signal}) =>
      GetUserManagementUserResponse.parse(await getUserManagementUser(userId, {signal})),
  });
}
